const RESERVED_TENANT_RUNTIME_ENV_KEYS = new Set([
  "PORT",
  "DATABASE_URL",
  "GENCOW_DB_URL",
  "BETTER_AUTH_SECRET",
  "BETTER_AUTH_URL",
  "IS_PLATFORM",
  "GENCOW_PLATFORM_CONFIG_FILE",
  "GENCOW_PLATFORM_URL",
  "GENCOW_PLATFORM_INTERNAL_URL",
  "GENCOW_PLATFORM_INTERNAL_URL_ALT",
  "GENCOW_PLATFORM_DB",
  "PLATFORM_OPENAI_KEY",
  "PLATFORM_GOOGLE_KEY",
  "PLATFORM_GOOGLE_CLIENT_ID",
  "PLATFORM_GOOGLE_CLIENT_SECRET",
  "PLATFORM_INTERNAL_SECRET",
  "INVITE_ONLY",
  "RUNNER_TYPE",
  "PGBOUNCER_PORT",
  "DIRECT_PG_PORT",
  "GENCOW_WAKE_SIGNAL_ENABLED",
  "GENCOW_WAKE_SIGNAL_DATABASE_URL",
  "GENCOW_REALTIME_OUTBOX_POLL_INTERVAL_MS",
  "GENCOW_WORKFLOW_RECONCILER_INTERVAL_MS",
  "GENCOW_FUNCTIONS",
  "GENCOW_STORAGE",
  "GENCOW_STORAGE_REQUIRE_READ_GRANT",
  "GENCOW_MIGRATIONS",
  "GENCOW_APP_NAME",
  "GENCOW_APP_DATA_DIR",
  "GENCOW_INTERNAL_TOKEN",
  "GENCOW_CRON_TOKEN",
  "GENCOW_DEPLOY_ID",
  "GENCOW_AI_PROXY_URL",
  "GENCOW_AI_PROXY_URL_ALT",
  "GENCOW_AI_PROXY_TOKEN",
  "GENCOW_METERING_URL",
  "GENCOW_METERING_URL_ALT",
  "GENCOW_START_REASON",
  "GENCOW_RESTART_ID",
  "GENCOW_SHUTDOWN_MARKER_PATH",
  "GENCOW_SKIP_MIGRATION",
  "GENCOW_DB_MAX_CONNECTIONS",
  "GENCOW_DB_IDLE_TIMEOUT_SECONDS",
  "GENCOW_DB_CONNECTION_TIMEOUT_SECONDS",
  "GENCOW_MEMORY_MB",
  "BUN_JSC_forceRAMSize",
  "MIMALLOC_PURGE_DELAY",
  "NODE_PATH",
]);

const RESERVED_TENANT_RUNTIME_ENV_PREFIXES = [
  "__GENCOW_",
  "GENCOW_DOCUMENT_",
  "GENCOW_TEMPLATE_",
  "GENCOW_WARM_",
];

export function isReservedTenantRuntimeEnvKey(key: string): boolean {
  const normalized = key.trim();
  return (
    RESERVED_TENANT_RUNTIME_ENV_KEYS.has(normalized) ||
    RESERVED_TENANT_RUNTIME_ENV_PREFIXES.some((prefix) => normalized.startsWith(prefix))
  );
}

export function filterTenantRuntimeEnvVars(vars: Record<string, string>): {
  allowed: Record<string, string>;
  rejectedKeys: string[];
} {
  const allowed: Record<string, string> = {};
  const rejectedKeys: string[] = [];

  for (const [key, value] of Object.entries(vars)) {
    if (isReservedTenantRuntimeEnvKey(key)) {
      rejectedKeys.push(key);
      continue;
    }
    allowed[key] = value;
  }

  return { allowed, rejectedKeys };
}
